import Icon from "@mui/material/Icon";

const ROUTE_DEFS = [
  { es: "Inicio", en: "Home", icon: "home", href: "#home" },
  { es: "Propiedades", en: "Properties", icon: "villa", href: "#properties" },
  { es: "Servicios", en: "Services", icon: "business", href: "#services" },
  { es: "Clientes", en: "Clients", icon: "groups", href: "#about" },
  { es: "Testimonios", en: "Testimonials", icon: "favorite", href: "#testimonials" },
  { es: "Contacto", en: "Contact", icon: "call", href: "#contact" },
];

export const getRoutes = (lang = "es") =>
  ROUTE_DEFS.map(({ es, en, icon, href }) => ({
    name: lang === "en" ? en : es,
    icon: <Icon>{icon}</Icon>,
    href,
  }));

export default getRoutes("es");
